var exports = {
  "iE": "x31de4314--af8976--wrapper",
  "tX": "x31de4314--af8976--title-container",
  "q1": "x31de4314--af8976--projects-list",
};

module.exports = exports;
